// Components
import TiptapHyperlinkTool from './TiptapHyperlinkTool';

export default TiptapHyperlinkTool;
